/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue.
 */

require('../bootstrap');

import _ from 'lodash';
import VeeValidate from 'vee-validate';
import { Validator } from 'vee-validate';
import pinia from './stores/store';
import '../main/dayjs-setup';



var _exchange = window.__pt.exchange || {};
var cultureInfo = __pt.cultureData;
var _settings = __pt.settings.site;


window.Vue = require('vue').default;

Vue.prototype.__ = (str, values = []) => {

    let formatted = _.get(window.i18n, str, str);

    if (values.length) {
        formatted = _.replace(formatted, /\{\d\}/g, (match) => {
            const index = match.replace(/\{|\}/g, '');
            return values[index] || match;
        });
    }

    return formatted;
}

Validator.extend('date_invalid', {
    getMessage: () => {
        return __('errors.date_invalid');
    },
    validate: value => {
        if (!value) return true;

        const [day, month, year] = value.split('/').map(Number);

        if (!day || !month || !year) return false;
        if (day < 1 || day > 31) return false;
        if (month < 1 || month > 12) return false;
        if (year < 1900) return false;

        const today = new Date();
        const inputDate = new Date(year, month - 1, day);

        if (
            inputDate.getFullYear() !== year ||
            inputDate.getMonth() !== month - 1 ||
            inputDate.getDate() !== day
        ) {
            return false;
        }

        if (inputDate > today) {
            return false;
        }

        return true;
    }
});


Validator.extend('date_expiration', {
    getMessage: () => {
        return __('errors.date_expiration');
    },
    validate: value => {
        if (!value) return true;

        const [day, month, year] = value.split('/').map(Number);

        if (!day || !month || !year) return false;
        if (day < 1 || day > 31) return false;
        if (month < 1 || month > 12) return false;
        if (year < 1900) return false;

        const inputDate = new Date(year, month - 1, day);

        if (
            inputDate.getFullYear() !== year ||
            inputDate.getMonth() !== month - 1 ||
            inputDate.getDate() !== day
        ) {
            return false;
        }

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        if (inputDate < today) {
            return false;
        }

        return true;
    }
});

Validator.extend('alpha_num_strict', {
    getMessage: () => {
        return __('errors.passport_invalid');
    },
    validate: value => /^[A-Za-z0-9]*$/.test(value)
});

window.dayjs.locale(__pt.settings.site.culture);



Vue.use(VeeValidate, {
    locale: __pt.settings.site.language,
    dictionary: {
        [__pt.settings.site.language]: {
            messages: window.i18n.errors, attributes: {}
        }
    }
});
//window.dayjs.locale(__pt.settings.site.culture);

/* Vue.filter('currency', function (value, currency = __pt.settings.site.currency) {
    if (typeof value !== "number") {
        return value;
    }
    var formatter = new Intl.NumberFormat(__pt.settings.site.culture, {
        style: 'currency',
        currency: currency,
        currencyDisplay: 'symbol',
        maximumFractionDigits: 0
    });
    return (formatter.format(value)).replace("$", __pt.settings.site.currencySymbol);
});
 */
Vue.filter('capitalising', function (word) {
    return word.charAt(0).toUpperCase() + word.slice(1);
});

Vue.filter('uppercase', function (v) {
    return v.toUpperCase();
});

Vue.filter('date', function (value, format = 'YYYY-MM-DD HH:mm') {
    if (value) {
        const raw = window.dayjs.parseZone(value).format(format).replace('.', '');

        // Capitalizar solo la primera letra de cada palabra usando split y join
        const formatted = raw.split(' ').map(word => {
            if (word.length > 0) {
                return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
            }
            return word;
        }).join(' ');

        return formatted;
    }
});

Vue.filter('currency', function (value, maximumFractionDigits = _settings.decimalDigits, applyConvertion = true) {

    const formatter = new Intl.NumberFormat(__pt.settings.site.cultureSite, {
        style: 'decimal',
        minimumFractionDigits: maximumFractionDigits,
        maximumFractionDigits: maximumFractionDigits,
    });

    return formatter.format(value * (applyConvertion ? _exchange.rate : 1)); 
});

Vue.filter('currencyBase', function (value, currency = _exchange.currency, maximumFractionDigits = _settings.decimalDigits, culture = __pt.settings.site.cultureSite) {

    if (typeof value !== "number") {
        return value;
    }

    let formatter = new Intl.NumberFormat(culture, {
        style: 'currency',
        currency,
        currencyDisplay: 'code',
        maximumFractionDigits: maximumFractionDigits
    });
    return (formatter.format(value)).replace(`${ currency }`, `${currency}`);

});
Vue.filter('currencyBaseFee', function (value, currency = _exchange.currency, maximumFractionDigits = _settings.decimalDigits, culture = __pt.settings.site.cultureSite) {

    if (typeof value !== "number") {
        return value;
    }

    let formatter = new Intl.NumberFormat(culture, {
        style: 'currency',
        currency,
        currencyDisplay: 'code',
        maximumFractionDigits: maximumFractionDigits
    });
    return (formatter.format(value)).replace(new RegExp(`\\s*${currency}\\s*`, 'g'), '') + ` ${currency}`;
});

Vue.filter('removedots', function (word) {
    return word.replaceAll('.','');
});

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

import bookerHotels from './booker/bookerHotels.vue';
import bookerFlights from './booker/bookerFlights.vue';
import bookerPackages from './booker/bookerPackages.vue';
import bookerTour from './booker/bookerTour.vue';
import bookerTransfers from './booker/bookerTransfers.vue';
import bookerCars from './booker/bookerCars.vue';

Vue.component('bookerHotels', bookerHotels);
Vue.component('bookerFlights', bookerFlights);
Vue.component('bookerPackages', bookerPackages);
Vue.component('bookerTour', bookerTour);
Vue.component('bookerTransfers', bookerTransfers);
Vue.component('bookerCars', bookerCars);


import promoBank from './cta/promoBank.vue';
import carrouselRecenSearch from './home/carrouselRecenSearch.vue';
Vue.component('promo-bank', promoBank);
Vue.component('carrousel-recen-search', carrouselRecenSearch);








const files = require.context('./', true, /\.vue$/i, 'lazy');
files.keys().forEach(key => {
    const componentName = key.split('/').pop().split('.')[0];
    if (!Vue.options.components[componentName] && !Vue.options.components[componentName.toLowerCase()]) {
        Vue.component(componentName, () => files(key));
    }
});

//Vue.component('example-component', require('./components/ExampleComponent.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// Buscar todos los contenedores que tengan data-vue y generar una instancia para cada uno :)
document.querySelectorAll('[data-vue]').forEach(el => {
    new Vue({
        el,
        pinia
    });
});

const app = new Vue({
    el: '#app-main'
});


Vue.use(pinia);
